import confetti from 'canvas-confetti';

/**
 * Triggers a multi-stage celebratory confetti explosion
 */
export function fireWinnerConfetti() {
  const duration = 2.5 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  // 1. Initial side cannons blast
  confetti({
    ...defaults,
    particleCount: 50,
    origin: { x: 0.15, y: 0.7 },
    colors: ['#6366F1', '#EC4899', '#F59E0B', '#10B981', '#3B82F6'],
  });
  confetti({
    ...defaults,
    particleCount: 50,
    origin: { x: 0.85, y: 0.7 },
    colors: ['#6366F1', '#EC4899', '#F59E0B', '#10B981', '#3B82F6'],
  });

  // 2. Continuous fireworks interval
  const interval: ReturnType<typeof setInterval> = setInterval(function () {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 40 * (timeLeft / duration);

    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.2, 0.4), y: Math.random() - 0.2 },
      colors: ['#FF007F', '#00F0FF', '#FFE600', '#7000FF'],
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.6, 0.8), y: Math.random() - 0.2 },
      colors: ['#F43F5E', '#FB923C', '#FBBF24', '#D946EF'],
    });
  }, 250);
}
